import React, { useEffect, useRef, useState } from 'react';
import Button from '../ui/Button';
import { useRequestBuilder } from '../context/RequestBuilderContext';
import { cn } from '../../utils/cn';

const AddToRequestButton = ({ item, className, size = 'sm' }) => {
  const { addItem, removeItem, hasItem } = useRequestBuilder();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const timerRef = useRef(null);
  const isAdded = hasItem(item?.id);
  const isUnavailable = item?.type?.toLowerCase() === 'product' && item?.isOutOfStock;

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleClick = (event) => {
    event?.stopPropagation();
    clearTimeout(timerRef.current);

    if (isAdded) {
      removeItem(item.id);
      setShowConfirmation(false);
      return;
    }

    addItem(item);
    setShowConfirmation(true);
    timerRef.current = setTimeout(() => setShowConfirmation(false), 1500);
  };

  const label = showConfirmation ? 'Added ✓' : isAdded ? 'In Request' : '+ Add to Request';

  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      onClick={handleClick}
      disabled={isUnavailable}
      aria-pressed={isAdded}
      className={cn(
        'transition-all duration-200',
        showConfirmation && 'border-success bg-success/10 text-success hover:bg-success/10 hover:text-success',
        isAdded && !showConfirmation && 'border-muted bg-muted text-muted-foreground',
        className
      )}
    >
      {label}
    </Button>
  );
};

export default AddToRequestButton;

